// Did `user/send-email` / `user/resend-email` actually send the code?
//
// The server answers `{ status: "success" }` when it sent, and `{ status: "error", message }`
// when it could not (e.g. its mailbox is down — 8 Oct 2026 every OTP silently failed while
// this screen opened an empty OTP drawer). `updateFunction` returns undefined on a network
// error, so anything that is not an explicit success is a failure.
export const OTP_SEND_FALLBACK_MESSAGE =
  "We couldn't send the code. Please try again in a few minutes.";

/** @returns null when the code was sent, otherwise the message to show the tenant. */
export function otpSendFailureMessage(response) {
  if (response?.status === "success") return null;
  return response?.message || OTP_SEND_FALLBACK_MESSAGE;
}
